import React from 'react';
import { string, bool } from 'prop-types';
import './Input.css';
import classNames from 'classnames';

const Input = ({
  id, className, label, error, isTextarea, labelStyles, styles, isRequired, inputWrapperStyles, ...attrs
}) => {
  let classes

  if (styles) {
    classes = styles(
      'input',
      className,
      { error },
    )
  } else {
    classes = classNames(
      'input',
      className,
      { error }
    )
  }

  const Tag = isTextarea ? 'textarea' : 'input'

  return (
    <div className={`inputWrapper ${inputWrapperStyles}`}>
      <div className="labelsWrapper">
        {label && <label className={`inputLabel ${labelStyles}`} htmlFor={id}>{label}</label>}
        {isRequired && <span className="inputRequired">*</span>}
      </div>
      <div className="inputErrorWrap">
        <Tag
          name={id}
          id={id}
          className={classes}
          {...attrs}
        />
        {error && <span className="inputError">{error}</span>}
      </div>
    </div>
  )
}

Input.propTypes = {
  id: string.isRequired,
  className: string,
  label: string,
  error: string,
  isRequired: bool,
  inputWrapperStyles: string,
  labelStyles: string,
}

Input.defaultProps = {
  className: '',
  label: '',
  error: '',
  isRequired: false,
  inputWrapperStyles: '',
  labelStyles: '',
}

export default Input